import * as React from 'react';
import { EventFunc } from 'types/types';


import './TextInput.pcss';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';

@observer
export class TextInput extends React.Component<{editMode?:boolean, disabled:boolean, value:string, onChangeValue:(value:string)=>void, placeholder?:string, onFocus?:EventFunc }  > {
  @observable private _editMode:boolean = false;
  @computed
  get editMode() {
    return this._editMode || this.props.editMode;
  }
  handleFocus = (e) => {
    this._editMode = true;
    if(this.props.onFocus) {
      this.props.onFocus(e);
    }
  }
  handleBlur = (e) => {
    this._editMode = false;
    const val = e.target.value.trim();
    this.props.onChangeValue(val);
  }
  handleChange = (e) => {
    this.props.onChangeValue(e.target.value);
  }
  render() {
    return (
      <input 
        type="text" 
        className={`textInput${this.editMode?' edit':''}`}
        value={this.props.value} 
        placeholder={this.props.placeholder} 
        disabled={this.props.disabled} 
        onFocus={this.handleFocus} 
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}





@observer
export class IntInput extends React.Component<{editMode?:boolean, disabled:boolean, value:number|string, onChangeValue:(value:number)=>void, placeholder?:string, onFocus?:EventFunc }> { 

  toInt(strVal:string){
    if(strVal.length==0) {
      return null;
    } else {
      try {
        return parseInt(strVal);
      } catch(e) {
        return null;
      }  
    }
  }

  handleChangeValue = (value) => {
    let v = value.trim();
    if(v.length>0) {
      v = v.replace(/[\D]/,'');
      if(v.length==0) {
        v = '';
      } else {
        try {
          v = parseInt(v);
        } catch(e) { 
          v = '';
        }   
      }
    }
    this.props.onChangeValue(v);
  }
  
  value = () => {
    if(null!=this.props.value && this.props.value>-1) {
      return ''+this.props.value;
    } else {
      return '';
    }
  }

  render() {
    return ( 
      <TextInput 
        value={this.value()}
        editMode={this.props.editMode} 
        onChangeValue={this.handleChangeValue} 
        onFocus={this.props.onFocus} 
        placeholder={this.props.placeholder} 
        disabled={this.props.disabled} 
      />
    );
  }
}





@observer
export class FloatInput extends React.Component<{editMode?:boolean, disabled:boolean, value:number|string, onChangeValue:(value:number)=>void, placeholder?:string, onFocus?:EventFunc }> { 

  // toInt(strVal:string){
  //   if(strVal.length==0) {
  //     return null;
  //   } else {
  //     try {
  //       return parseInt(strVal);
  //     } catch(e) {
  //       return null;
  //     }  
  //   }
  // }
  // onlyDecimals(event) {
  //   if (event.shiftKey == true) {
  //     event.preventDefault();
  //   }
  //   if((event.keyCode >= 48 && event.keyCode <= 57) || 
  //     (event.keyCode >= 96 && event.keyCode <= 105) || 
  //     event.keyCode == 8 || 
  //     event.keyCode == 9 || 
  //     event.keyCode == 37 ||
  //     event.keyCode == 39 || 
  //     event.keyCode == 46 || 
  //     event.keyCode == 190) {
  //     // key accepted
  //   } else {
  //       event.preventDefault();
  //   }
  //   // if a decimal has already been added, reject any additional "."
  //   if(j$(this).val().indexOf('.') !== -1 && event.keyCode == 190) {
  //     event.preventDefault(); 
  //   }
  // }
      

  handleChangeValue = (value) => {
    let v = value.trim();
    if(v.length>0) {
      v = v.replace(/[^0-9.]/g,'');      
      let varray = v.split('.');
      v = varray.shift() + (varray.length ? '.' + varray.join('') : '');
      if(v.length==0) {
        v = '';
      } else {
        try {
          parseFloat(v); //parseInt(v);
        } catch(e) { 
          v = '';
        }   
      }
    }
    this.props.onChangeValue(v);
  }
  
  value = () => {
    if(null!=this.props.value && this.props.value>-1) {
      return ''+this.props.value;
    } else {
      return '';
    }
  }

  render() {
    return ( 
      <TextInput 
        value={this.value()}
        editMode={this.props.editMode} 
        onChangeValue={this.handleChangeValue} 
        onFocus={this.props.onFocus} 
        placeholder={this.props.placeholder} 
        disabled={this.props.disabled} 
      />
    );
  }
}
